import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';

const PlayerProfilePage = () => {
  const { token } = useContext(AuthContext);

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const [photoURL, setPhotoURL] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadMsg, setUploadMsg] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      const res = await fetch('https://vballbackend.onrender.com/api/profile', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok) setPhotoURL(data.photo_url || '');
    };
    fetchProfile();
  }, [token]);

  const handleChangePassword = async () => {
    setMsg('');
    if (!oldPassword || !newPassword || !confirmPassword) {
      setMsg('All fields are required.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMsg('New passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch('https://vballbackend.onrender.com/api/change_password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword
        })
      });

      const data = await res.json();
      if (!res.ok) {
        setMsg(data.msg || 'Password change failed.');
      } else {
        setMsg('✅ Password updated successfully.');
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
      }
    } catch (err) {
      setMsg('Server error. Please try again.');
    }

    setLoading(false);
  };

  const handlePhotoUpload = async () => {
    setUploadMsg('');
    if (!selectedFile) {
      setUploadMsg('No file selected.');
      return;
    }

    const formData = new FormData();
    formData.append('photo', selectedFile);

    try {
      const res = await fetch('https://vballbackend.onrender.com/api/upload_photo', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });

      const data = await res.json();
      if (!res.ok) {
        setUploadMsg(data.msg || 'Upload failed.');
      } else {
        setUploadMsg('✅ Photo uploaded successfully.');
        setPhotoURL(data.photo_url);
      }
    } catch (err) {
      setUploadMsg('Server error. Please try again.');
    }
  };

  return (
    <div className="container" style={{ maxWidth: 500, marginTop: '3rem' }}>
      <h2 className="mb-4">Profile Settings</h2>

      {/* Password Change */}
      <h4 className="mb-3">Password Change</h4>
      <div className="flex-col" style={{ display: 'flex', gap: '1rem' }}>
        <input
          type="password"
          placeholder="Old Password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <input
          type="password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        <button className="btn-primary" onClick={handleChangePassword} disabled={loading}>
          {loading ? 'Changing...' : 'Change Password'}
        </button>
      </div>
      {msg && (
        <p style={{ marginTop: '1rem', color: msg.includes('✅') ? 'green' : 'red' }}>
          {msg}
        </p>
      )}

      {/* Profile Photo Upload */}
      <h4 className="mt-5 mb-3">Profile Photo</h4>
      <div className="flex-col" style={{ display: 'flex', gap: '1rem' }}>
        {photoURL ? (
          <img
            src={photoURL}
            alt="Profile"
            style={{
              width: 100,
              height: 100,
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
        ) : (
          <p>No photo</p>
        )}
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setSelectedFile(e.target.files[0])}
        />
        <button className="btn-primary" onClick={handlePhotoUpload}>Upload Photo</button>
      </div>
      {uploadMsg && (
        <p style={{ marginTop: '1rem', color: uploadMsg.includes('✅') ? 'green' : 'red' }}>
          {uploadMsg}
        </p>
      )}
    </div>
  );
};

export default PlayerProfilePage;
